module.exports = __webpack_public_path__ + "static/media/fly0142.c5bb65e7.webp";